// extracted by mini-css-extract-plugin
export default {"card":"card_card__qwoPi","title":"card_title__7KUTV","img":"card_img__FaRo8","imgInner":"card_imgInner__iyT4V"};